import React from "react";
import { Redirect } from "react-router-dom";
import DonateFeature from "./DonateFeature";
import { legacyDonateQueryToCanonical } from "../Helper/entityRoutes";

/**
 * Generic /donate entry: redirect branded legacy query URLs to canonical
 * /:entity/:slug/donate/checkout; otherwise render Pentecost+ DonateFeature.
 */
function DonatePageEntry(props) {
  const canonical = legacyDonateQueryToCanonical(
    props.location && props.location.search
  );
  if (canonical) {
    return <Redirect to={canonical} />;
  }
  return <DonateFeature {...props} />;
}

export default DonatePageEntry;
